import {Injectable} from '@angular/core';
import {filter, map} from "rxjs/operators";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {IBreadCrumb} from "./IBreadCrumb";
import _ from "lodash";

export class Breadcrumb implements IBreadCrumb{
   label: string = ""
   url: string = ""
   cssClass?: string = "";
   key?: string = "";
}


@Injectable({
   providedIn: 'root'
})
export class BreadcrumbService {

   public static instance:BreadcrumbService;
   public breadcrumbs: IBreadCrumb[] = []

   constructor(private router:Router,
               private sanitizer:DomSanitizer,
               private activatedRoute: ActivatedRoute) {

      console.log("[BreadcrumbService] init")

      BreadcrumbService.instance = this

      this.router.events.pipe(
         filter((event) => {return event instanceof NavigationEnd;}),
         map(_ => this.router.routerState.root),
         map(route => {
            while (route.firstChild) route = route.firstChild;
            return route;
         }),
      ).subscribe((route) => {
         this.buildBreadCrumb(route);
      })
   }

   private replaceRouterVariable(route:ActivatedRoute, b:IBreadCrumb, value:any){
      if(!value) return "-";

      let regex = new RegExp('\{\{(.*?)\}\}', 'g')
      var matches = value.match(regex);

      if(matches){
         for (let i = 0; i < matches.length; i++) {
            let m = matches[i]
            let key = m.substr(2, m.length-4)
            let param = route.snapshot.params[key]

            if(param){
               value = value.replace(m, param)
               continue
            }

            if(route.parent){
               let p = route.parent.snapshot.params[key]
               if(p){
                  value = value.replace(m, p)
                  continue
               }
            }
         }
      }

      return value
   }

   buildBreadCrumb(route:ActivatedRoute){
      // https://stackoverflow.com/questions/3598042/how-can-i-replace-a-regex-substring-match-in-javascript
      let breadcrumbs: IBreadCrumb[] = route.snapshot.data.breadcrumb as any
      if(!breadcrumbs) return

      let useBreadcrumbParent = route.snapshot.data.useBreadcrumbParent

      // alert(useBreadcrumbParent)

      breadcrumbs = _.cloneDeep(breadcrumbs)

      _.map(breadcrumbs, (b:any)=>{
         b.label = this.replaceRouterVariable(route, b, b.label);
         b.url = this.replaceRouterVariable(route, b, b.url);
         b.cssClass = ""
      })

      // if(breadcrumbs.length > 2 ){
      //    for(let i=0;i<breadcrumbs.length-2;i++){
      //       breadcrumbs[i].cssClass = "d-none d-sm-block"
      //    }
      // }

      let ris:Breadcrumb[] = []

      // console.group("Breadcrumb")
      // console.log(this.breadcrumbs.length)
      // console.log(breadcrumbs.length)
      // console.groupEnd()

      if(this.breadcrumbs && this.breadcrumbs.length == breadcrumbs.length){
         // console.log("* ciclo " + this.breadcrumbs.length)
         for (let i = 0; i < breadcrumbs.length; i++) {
            let b:any = breadcrumbs[i]
            if(b.label){
               ris.push(b)
            }else{
               ris.push(this.breadcrumbs[i])
            }
         }
      }else{
         ris = breadcrumbs
         // ris = [{label: "Dashboard", url:"/admin/dashboard"}]
      }
      this.breadcrumbs = ris
   }

   public updateLabel(key:any, value:any){
      let ris:Breadcrumb|undefined = _.find(this.breadcrumbs, {key:key})
      if(ris){
         ris.label = value
      }else{
         console.warn(`key: ${key} not found`)
         console.log(this.breadcrumbs)
      }
   }

   public updateUrl(key:any, value:any){
      let ris:Breadcrumb|undefined = _.find(this.breadcrumbs, {key:key})
      if(ris){
         ris.url = value
      }else{
         console.warn(`key: ${key} not found`)
         console.log(this.breadcrumbs)
      }
   }

}
